import { FC, Fragment } from "react";

import { MembershipRenewalCard } from "../../rows/MembershipRenewalCard";
import { ThankYouEmailCard } from "../../rows/ThankYouEmailCard";
import { AutomatedCommunicationsFormData, RowKey } from "../../types";

interface MembershipRowsProps {
  showRenewalEmails: boolean;
  hasExpiringRates: boolean;
  hasAutoRenewalRates: boolean;
  openRow: RowKey | null;
  onToggleOpen: (row: RowKey) => void;
  defaultValues: AutomatedCommunicationsFormData;
  hasDate: boolean;
  hasLocation: boolean;
}

export const MembershipRows: FC<MembershipRowsProps> = ({
  showRenewalEmails,
  hasExpiringRates,
  hasAutoRenewalRates,
  openRow,
  onToggleOpen,
  defaultValues,
  hasDate,
  hasLocation,
}) => {
  const shared = { openRow, onToggleOpen };

  const rows: { key: RowKey; node: React.ReactNode }[] = [
    {
      key: "thank-you-email",
      node: (
        <ThankYouEmailCard
          {...shared}
          defaultContent={defaultValues.thankYouWinner.content}
          hasDate={hasDate}
          hasLocation={hasLocation}
        />
      ),
    },
  ];

  if (showRenewalEmails && hasExpiringRates) {
    rows.push({
      key: "expiring-membership",
      node: (
        <MembershipRenewalCard kind="expiring" {...shared} defaultContent={defaultValues.expiringMembership.content} />
      ),
    });
  }

  if (showRenewalEmails && hasAutoRenewalRates) {
    rows.push({
      key: "auto-renewal",
      node: (
        <MembershipRenewalCard kind="auto-renewal" {...shared} defaultContent={defaultValues.autoRenewal.content} />
      ),
    });
  }

  return (
    <>
      {rows.map(({ key, node }) => (
        <Fragment key={key}>{node}</Fragment>
      ))}
    </>
  );
};
